import React from 'react';
import { ClassAssembly3B2026 } from '../views';


const ClassAssemblyPage = () => {
    return <ClassAssembly3B2026/>;
  };
  
  export default ClassAssemblyPage;